var module = angular.module('octopusApp.shared');

// Allows editing of sensitive-values
module.directive('sensitiveInput', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      model: '='
    },
    templateUrl: 'areas/shared/views/sensitive-input.html',
    link: function($scope, element, attr) {
      $scope.setOrChange = "Set";

      $scope.$watch(function () {
        if (!$scope.model) {
          return;
        }

        if ($scope.model.HasValue) {
          $scope.setOrChange = "Change";
          $scope.hasPassword = true;
        } else {
          $scope.setOrChange = "Set";
          $scope.hasPassword = false;
        }
      });

      $scope.isEditingPassword = false;
      $scope.set = function() {
        $scope.model = $scope.model || {};
        $scope.isEditingPassword = true;
        $scope.hadValue = $scope.model.HasValue;
        $scope.model.NewValue = '';
      };
      $scope.clear = function() {
        $scope.isEditingPassword = false;
        $scope.hadValue = $scope.model.HasValue;
        $scope.model.NewValue = null;
        $scope.model.HasValue = false;
      };
      $scope.undo = function() {
        $scope.isEditingPassword = false;
        $scope.model.NewValue = null;
        $scope.model.HasValue = $scope.hadValue || false;
      };
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/sensitive_input.js
// module id = 601
// module chunks = 1